export const DELETE_TRANSACTION = "DELETE_TRANSACTION";
export const DELETE_TRANSACTION_MODAL = "DELETE_TRANSACTION_MODAL";
export const UPDATE_TRANSACTION_MODAL = "UPDATE_TRANSACTION_MODAL";
export const UPDATE_TRANSACTION = "UPDATE_TRANSACTION";
export const REGISTER_TRANSACTION = "REGISTER_TRANSACTION";
export const REGISTER_TRANSACTIONS = "REGISTER_TRANSACTIONS";
export const SET_TRANSACTION = "SET_TRANSACTION";
export const RESET_TRANSACTION = "RESET_TRANSACTION";
export const ADD_TRANSACTION_MODAL = "ADD_TRANSACTION_MODAL";

export const resetTransaction = () => ({
  type: RESET_TRANSACTION,
});

export const deleteTransaction = (form: any) => ({
  type: DELETE_TRANSACTION,
  form,
});

export const deleteTransactionModal = (transaction: any) => ({
  type: UPDATE_TRANSACTION_MODAL,
  transaction,
});

export const setTransaction = (transaction: any) => ({
  type: SET_TRANSACTION,
  transaction,
});

export const updateTransactionModal = (transaction: any) => ({
  type: UPDATE_TRANSACTION_MODAL,
  transaction,
});

export const updateTransaction = (form: any) => ({
  type: UPDATE_TRANSACTION,
  form,
});

export const registerTransaction = (transaction: any) => ({
  type: REGISTER_TRANSACTION,
  transaction,
});

export const registerTransactions = (transaction: any) => ({
  type: REGISTER_TRANSACTIONS,
  transaction,
});

const initialState = {
  transaction: null,
};

export const transactionReducer = (state = initialState, action: any) => {
  const { transaction } = action;
  const { form } = action;
  switch (action.type) {
    case DELETE_TRANSACTION:
      return { ...state, form };
    case DELETE_TRANSACTION_MODAL:
      return { ...state, transaction };
    case UPDATE_TRANSACTION_MODAL:
      return { ...state, transaction };
    case UPDATE_TRANSACTION:
      return { ...state, form };
    case REGISTER_TRANSACTION:
      return { ...state, transaction };
    case SET_TRANSACTION:
      return { ...state, transaction };
    case RESET_TRANSACTION:
      return initialState;
    default:
      return state;
  }
};
